import { useFlags } from "launchdarkly-react-client-sdk";
import { EventPaymentPlan } from "src/types";

import useEvent from "./use-event";

export const useAdvancedFeatures = () => {
  const { event } = useEvent();
  const flags = useFlags();
  const paymentPlanName = event.organization.payment_plan_name;
  const paymentPlanAdvanced = event.organization.payment_plan_advanced;
  const isFreeTrial = Boolean(flags.eventsFreeTrial);

  return {
    advancedFeaturesEnabled:
      paymentPlanAdvanced ||
      (paymentPlanName === EventPaymentPlan.FREE && isFreeTrial),
  };
};
